/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHallOfFame = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M13.47 3.977 12 1l-1.47 2.977-3.285.478 2.377 2.318-.56 3.272L12 8.5l2.939 1.545-.561-3.272 2.377-2.318zm-8.2 3.567A2 2 0 1 0 3 7.733V19H1v2h6v-2H5v-7.417l.008.01C6.406 13.49 8.65 15 12 15s5.594-1.51 6.992-3.406l.008-.01V19h-2v2h6v-2h-2V7.732a2 2 0 1 0-2.271-.188c-.25.931-.679 1.957-1.346 2.863C16.323 11.843 14.65 13 12 13s-4.323-1.156-5.383-2.594c-.667-.905-1.096-1.93-1.346-2.862z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHallOfFame as HallOfFame };
